'use strict';

var twentyninetimes = twentyninetimes || {};

twentyninetimes.imageOverlay = twentyninetimes.imageOverlay || function () {

	function init() {
        var overlayImages = document.querySelectorAll('.is-style-image-overlay');
        if ( overlayImages ) {
            imageOverlayHandler(overlayImages);
        }
    }

    function imageOverlayHandler(overlayImages) {
        var overlay = document.getElementById('js-overlay-embed'),
            appendWrapper = overlay.querySelector('.overlay-embed__inner');

        overlayImages.forEach((image) => {
            image.addEventListener('click', (e) => {
                e.stopPropagation();

                var src = image.querySelector('img').getAttribute('src');

                if ( !overlay.classList.contains('has-image') ) {
                    overlay.classList.add('active');

                    var figure = document.createElement('figure'),
                        img = document.createElement('img');

                    figure.setAttribute('class', 'wp-block-image');
                    img.setAttribute('src', src);

                    figure.appendChild(img);
                    appendWrapper.appendChild(figure);

                    setTimeout(function() {
                        overlay.classList.add('has-iframe');
                    }, 600);

                    ( document.documentElement )
                        ? document.documentElement.classList.add('no-scroll')
                        : document.body.classList.add('no-scroll');

                    bodyScrollLock.disableBodyScroll(overlay);
                }
            });
        });
    }
    
	return {
		init : init
	};

}();